import { PackageGeneralFormBaseDataProvider } from './PackageGeneralFormBaseDataProvider';
import { sanitizeArray } from '../../../../utils/sanitization.utils';
import { LanguageData } from '../../../types/language-data';

export class PackageGeneralFormGzDataProvider extends PackageGeneralFormBaseDataProvider {
  public getLanguages(): LanguageData[] {
    const data = this.dependencies.getLanguages();
    return sanitizeArray(data);
  }
}
